require('./../raw-html.tag');

riot.tag2('dealer-badge', '<div class="dealer-badge-box {\'is-clickable\': badgeDescription && badgeDescription !== \'\'}" onclick="{toggleDescription}"> <div class="dealer-badge-box-header"> <figure class="dealer-badge-container" if="{badgeItem.IconUrl && badgeItem.IconUrl !== \'\'}"> <img riot-src="{badgeItem.IconUrl}" alt="{badgeName}"> </figure> <span class="dealer-badge-name acr-paragraph-7"><raw-html content="{badgeName}"></raw-html></span> </div> <div class="dealer-badge-detail acr-paragraph-7 {\'is-open\': showDescription}"> <p class="dealer-badge-copy"><raw-html content="{badgeDescription}"></raw-html></p> </div> <i class="dealer-badge-icon {\'dl-icon-plus\': showDescription == false, \'dl-icon-minus\': showDescription == true}" show="{badgeDescription && badgeDescription !== \'\'}"> </i> </div>', '', 'class="dealer-badge"', function(opts) {
    var self = this;
    var trackingJSON = require('../../data/tracking-data');

    this.mixin('bus');

    self.showDescription = false;

    function triggerTrackingDataBadge() {
      var jsonData = JSON.parse(JSON.stringify(trackingJSON.expandDepartments));
      jsonData.Dealer.selected_dealer_id = self.parent.opts.dealer.DealerNumber;
      jsonData.Dealer.selected_dealer_zipcode = self.parent.opts.dealer.ZipCode;
      jsonData.Dealer.selected_dealer_name = self.parent.opts.dealer.Name;
      jsonData.Dealer.selected_dealer_address = self.parent.opts.dealer.Address
                                                        + ', ' + self.parent.opts.dealer.City;

      if (self.showDescription) {
        jsonData.dynamic_variables[0].search += 'collapse ' + self.badgeName;
      } else {
        jsonData.dynamic_variables[0].search += 'expand ' + self.badgeName;
      }

      if (window.Acr.TrackingManager) {
        window.Acr.TrackingManager.clickActivity(jsonData);
      }
    }

    function resetDescription() {
      self.showDescription = false;
    }

    function toggleDescription() {
      triggerTrackingDataBadge();

      if (self.badgeDescription && self.badgeDescription !== '') {
        self.showDescription = !self.showDescription;
      }
    }

    this.on('update', function onUpdate() {
      self.badgeDescription = self.badgeItem.FullDescription
        ? self.badgeItem.FullDescription : self.badgeItem.Description;
      self.badgeName = self.badgeItem.FriendlyName
        ? self.badgeItem.FriendlyName : self.badgeItem.Name;
    });

    self.toggleDescription = toggleDescription;

    this.bus.on(this.bus.EVENTS.DEALERS.CLOSE_DETAIL, resetDescription);
});
